import styled from "styled-components"

import { useAppDispatch } from "store/hooks"
import { showAccountSettingsModal } from "store/modalSlise"
import { setAccountSettingsTab } from "store/tempDataSlise"
import { ReactComponent as SettingsIcon } from "assets/svg/icon-settings.svg"

import useUrlQueryParams from "hooks/useUrlQueryParams"
import { AccountSettingsTabs } from "modals/AccountSettingsModal"
import { ToggleButton } from "components/form/ToggleButton"

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

const Title = styled.h1`
  font-size: 24px;
  line-height: 32px;
  margin: 0;
`

const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  justify-content: flex-end;
`

const SettingsButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }

  svg {
    width: 24px;
    height: 24px;
  }
`

export const NotificationsHeader = () => {
  const dispatch = useAppDispatch()
  const { urlQueryParams, setUrlQueryParams } = useUrlQueryParams()

  const showUnreadOnly = urlQueryParams["isRead"] === "false"

  const handleToggleUnread = () => {
    setUrlQueryParams({ ...urlQueryParams, isRead: showUnreadOnly ? null : "false", page: "1" })
  }

  const handleOpenSettings = () => {
    dispatch(setAccountSettingsTab(AccountSettingsTabs.NOTIFICATIONS))
    dispatch(showAccountSettingsModal(true))
  }

  return (
    <Header>
      <Title>Notifications History</Title>
      <HeaderRight>
        <ToggleButton id="unread-toggle" isChecked={showUnreadOnly} onChange={handleToggleUnread} isReverse>
          Unreads
        </ToggleButton>
        <SettingsButton onClick={handleOpenSettings}>
          <SettingsIcon />
        </SettingsButton>
      </HeaderRight>
    </Header>
  )
}
